// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-write-redesign-layout {
  min-height: 100vh;
}

.admin-write-redesign-content {
  flex: 1 1;
  min-width: 0;
  padding: 30px 36px;
  background: #f5f7fb;
  box-sizing: border-box;
}

.aw-page {
  width: 100%;
  color: #203047;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}

.aw-top {
  margin-bottom: 22px;
}

.aw-back {
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.aw-back:hover {
  color: #168ff0;
}

.aw-heading {
  margin-bottom: 24px;
}

.aw-heading h2 {
  margin: 0 0 8px;
  font-size: 25px;
  font-weight: 800;
}

.aw-heading p {
  margin: 0;
  font-size: 14px;
  color: #8190a4;
}

.aw-card {
  background: #fff;
  border: 1px solid #e4eaf1;
  border-radius: 12px;
  padding: 26px;
  box-shadow: 0 2px 12px #19355409;
  margin-bottom: 22px;
}

.aw-card-title {
  padding-bottom: 18px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e9edf3;
}

.aw-card-title h3 {
  margin: 0 0 6px;
  font-size: 19px;
  font-weight: 800;
}

.aw-card-title span {
  font-size: 13px;
  color: #8190a4;
}

.aw-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px 22px;
}

.aw-field {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.aw-field label {
  color: #75849a;
  font-size: 14px;
  font-weight: 600;
}

.aw-field label em,
.aw-required-note em {
  color: #dc2626;
  font-style: normal;
  font-weight: 700;
}

.aw-field input,
.aw-field select {
  width: 100%;
  min-width: 0;
  height: 44px;
  box-sizing: border-box;
  border: 1px solid #dce4ee;
  border-radius: 8px;
  padding: 0 12px;
  background: #fff;
  color: #203047;
  font-size: 14px;
}

.aw-field input:focus,
.aw-field select:focus {
  outline: 2px solid #90c7ff;
  outline-offset: 1px;
}

.aw-required-note {
  margin: 0;
  color: #8190a4;
  font-size: 13px;
}

.aw-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.aw-actions button {
  border-radius: 9px;
  padding: 13px 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.aw-secondary {
  border: 1px solid #dce4ee;
  background: #fff;
  color: #475569;
}

.aw-primary {
  border: 1px solid #168ff0;
  background: #168ff0;
  color: #fff;
}

.aw-primary:hover {
  background: #087bd4;
}

@media (max-width: 1100px) {
  .aw-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .admin-write-redesign-content {
    padding: 20px 16px;
  }

  .aw-card {
    padding: 20px;
  }

  .aw-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminWriteRedesign.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".admin-write-redesign-layout {\n  min-height: 100vh;\n}\n\n.admin-write-redesign-content {\n  flex: 1;\n  min-width: 0;\n  padding: 30px 36px;\n  background: #f5f7fb;\n  box-sizing: border-box;\n}\n\n.aw-page {\n  width: 100%;\n  color: #203047;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n\n.aw-top {\n  margin-bottom: 22px;\n}\n\n.aw-back {\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.aw-back:hover {\n  color: #168ff0;\n}\n\n.aw-heading {\n  margin-bottom: 24px;\n}\n\n.aw-heading h2 {\n  margin: 0 0 8px;\n  font-size: 25px;\n  font-weight: 800;\n}\n\n.aw-heading p {\n  margin: 0;\n  font-size: 14px;\n  color: #8190a4;\n}\n\n.aw-card {\n  background: #fff;\n  border: 1px solid #e4eaf1;\n  border-radius: 12px;\n  padding: 26px;\n  box-shadow: 0 2px 12px #19355409;\n  margin-bottom: 22px;\n}\n\n.aw-card-title {\n  padding-bottom: 18px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid #e9edf3;\n}\n\n.aw-card-title h3 {\n  margin: 0 0 6px;\n  font-size: 19px;\n  font-weight: 800;\n}\n\n.aw-card-title span {\n  font-size: 13px;\n  color: #8190a4;\n}\n\n.aw-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px 22px;\n}\n\n.aw-field {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.aw-field label {\n  color: #75849a;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.aw-field label em,\n.aw-required-note em {\n  color: #dc2626;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.aw-field input,\n.aw-field select {\n  width: 100%;\n  min-width: 0;\n  height: 44px;\n  box-sizing: border-box;\n  border: 1px solid #dce4ee;\n  border-radius: 8px;\n  padding: 0 12px;\n  background: #fff;\n  color: #203047;\n  font-size: 14px;\n}\n\n.aw-field input:focus,\n.aw-field select:focus {\n  outline: 2px solid #90c7ff;\n  outline-offset: 1px;\n}\n\n.aw-required-note {\n  margin: 0;\n  color: #8190a4;\n  font-size: 13px;\n}\n\n.aw-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.aw-actions button {\n  border-radius: 9px;\n  padding: 13px 24px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.aw-secondary {\n  border: 1px solid #dce4ee;\n  background: #fff;\n  color: #475569;\n}\n\n.aw-primary {\n  border: 1px solid #168ff0;\n  background: #168ff0;\n  color: #fff;\n}\n\n.aw-primary:hover {\n  background: #087bd4;\n}\n\n@media (max-width: 1100px) {\n  .aw-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-write-redesign-content {\n    padding: 20px 16px;\n  }\n\n  .aw-card {\n    padding: 20px;\n  }\n\n  .aw-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
